import { Box, Link as MuiLink, Typography } from '@mui/material';
import React from 'react';

import { AcfTopStoryBlockProps } from '@orgnc/core/components/blocks/Blocks/types';

import { FrameLayout } from '@orgnc/core/components/primitives';
import {
  DisablePrefetchLink,
  FastlyOptimizedImage,
} from '@orgnc/core/components/atoms';

const AcfTopStoryBlockHeroLayoutACH = ({
  area,
  className,
  frequency,
  post,
}: AcfTopStoryBlockProps) => {
  return (
    <Box
      sx={{ position: 'relative', overflow: 'hidden', cursor: 'pointer' }}
      component="article"
      className={className}
      data-og-block-area={area}
      data-og-block-nth={frequency}
    >
      {post.featuredImage && (
        <Box
          sx={{
            ':after': {
              content: '""',
              position: 'absolute',
              inset: 0,
              background:
                'linear-gradient(to top, rgba(0,0,0,.5) 0%, transparent 25%)',
            },
          }}
        >
          <FrameLayout ratio={'16:10'}>
            <FastlyOptimizedImage
              alt={post.featuredImage?.node?.altText || ''}
              src={post.featuredImage?.node?.sourceUrl || ''}
            />
          </FrameLayout>
        </Box>
      )}
      {/* Children */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          zIndex: 1,
          color: 'white',
          p: {
            md: 2,
            xs: 0,
          },
          a: {
            color: 'white',
            textDecoration: 'none',

            ':hover': {
              textDecoration: 'underline',
            },
          },
        }}
      >
        <DisablePrefetchLink passHref href={post.uri || 'a'}>
          <Box
            sx={{
              display: 'flex',
              flex: 1,
              flexDirection: 'column',
              p: 4,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                justifyContent: 'flex-end',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              {/* Title */}
              <Box>
                <DisablePrefetchLink href={post?.uri || '#'} passHref>
                  <Typography
                    aria-label={post?.title || ''}
                    component="a"
                    variant="h3"
                    fontWeight={400}
                    fontFamily={'Arial, sans-serif'}
                    sx={{
                      fontSize: {
                        xs: 18,
                        md: 36,
                      },
                    }}
                  >
                    {post?.title}
                  </Typography>
                </DisablePrefetchLink>

                {/* Subtitle */}
                {post?.excerpt && (
                  <Typography
                    aria-label={post?.excerpt || ''}
                    color="white"
                    component="h4"
                    fontWeight={600}
                    dangerouslySetInnerHTML={{ __html: post.excerpt }}
                    sx={{
                      display: {
                        xs: 'none',
                        sm: 'block',
                      },
                      my: 3,
                      fontSize: {
                        xs: 14,
                        md: 18,
                      },
                    }}
                    variant="subtitle1"
                  />
                )}
              </Box>
              {/* Article Author(s) Underline */}
              {post?.authorTags?.nodes?.length ? (
                <DisablePrefetchLink
                  href={post?.authorTags.nodes[0]?.uri || '#'}
                  passHref
                >
                  <MuiLink
                    aria-label={post?.authorTags.nodes[0]?.name || ''}
                    fontSize={16}
                    sx={{ fontWeight: 400 }}
                    variant="caption"
                  >
                    By {post?.authorTags.nodes[0]?.name}
                  </MuiLink>
                </DisablePrefetchLink>
              ) : null}
            </Box>
          </Box>
        </DisablePrefetchLink>
      </Box>
    </Box>
  );
};

export default AcfTopStoryBlockHeroLayoutACH;
